'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../../../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoItemPlaceholder = function (_React$Component) {
  (0, _inherits3.default)(VideoItemPlaceholder, _React$Component);

  function VideoItemPlaceholder() {
    (0, _classCallCheck3.default)(this, VideoItemPlaceholder);
    return (0, _possibleConstructorReturn3.default)(this, (VideoItemPlaceholder.__proto__ || (0, _getPrototypeOf2.default)(VideoItemPlaceholder)).apply(this, arguments));
  }

  (0, _createClass3.default)(VideoItemPlaceholder, [{
    key: 'render',
    value: function render() {
      var baseClassName = 'gallery-item-visible gallery-item-preloaded gallery-item-video gallery-item';
      return _react2.default.createElement(
        'div',
        { key: 'video-and-hover-container' + this.props.id },
        _react2.default.createElement(
          'div',
          { className: baseClassName, key: 'video-placeholder-container-' + this.props.id,
            style: _utils2.default.deviceHasMemoryIssues() ? {} : { backgroundImage: 'url(' + this.props.resized_url.thumb + ')' } },
          this.props.hover,
          _react2.default.createElement('div', { className: 'gallery--placeholder-item', key: 'video-' + this.props.id })
        )
      );
    }
  }]);
  return VideoItemPlaceholder;
}(_react2.default.Component);

exports.default = VideoItemPlaceholder;